angular.module('app.controllers').controller('ClientsCtrl', function ($translate, DataTablesFactory, clientsListFilter, clientsList) {
    const vm = this;

    vm.clients = clientsList;
    vm.filter = clientsListFilter;

    vm.dt = DataTablesFactory.init({
        scope: vm,
    });
});
